import { render } from "./FormIndex.vue?vue&type=template&id=67ad7f92&scoped=true&ts=true"
import script from "./FormIndex.vue?vue&type=script&lang=ts"
export * from "./FormIndex.vue?vue&type=script&lang=ts"

import "./FormIndex.vue?vue&type=style&index=0&id=67ad7f92&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ad7f92"]])

export default __exports__